(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const track = (name, detail = {}) => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
    document.dispatchEvent(new CustomEvent("dominator:track", { detail: { name, ...detail } }));
  };

  const escapeHtml = (value = "") => String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const supportDrawer = $("[data-support-drawer]");
  const supportStatus = $("[data-support-status]");
  const supportModes = {
    buying: ["Ask Before Buying", "Compare products, dimensions, install timing, and fit before checkout."],
    contact: ["Contact Dominator", "Send a general request with source page context attached."],
    planner: ["Court Planning", "Share court dimensions, product ideas, and planning questions."],
    installer: ["Installer Help", "Send the zip and project type so Dominator can route the right next step."],
    parts: ["Parts And Accessories", "Ask for replacement parts, padding, accessories, or SKU help."],
    support: ["Support Or Warranty", "Send order, product, and issue context so support can review it."]
  };

  const supportSuggestionBank = [
    { question: "What size hoop should I buy?", answer: "Start with available court space and use. A 72 inch hoop feels closest to regulation when space allows, 60 inch keeps a premium feel in tighter driveways, and 54 inch fits compact family play.", keywords: "size hoop 72 60 54 driveway court fit regulation", href: "/products/dominator-72-inch-basketball-hoop#product-decisions" },
    { question: "Glass or shatterproof backboard?", answer: "Glass has the classic rebound and look. The shatterproof aluminum Pro story is durability, weather resistance, and long-term curb appeal when abuse or weather matters.", keywords: "glass shatterproof aluminum backboard rebound durability weather", href: "/products/dominator-pro-72-basketball-hoop-shatterproof-aluminum-backboard#product-compare" },
    { question: "How does installation work?", answer: "Most projects need concrete, alignment, clearance, delivery access, and lifting help planned before install. The installer route is best when the site has slope, access, or timing constraints.", keywords: "install installation installer concrete anchor alignment delivery access", href: "/pages/installer-locator" },
    { question: "Can I add lights later?", answer: "Yes. Lighting can be a second phase. The useful details are power access, court dimensions, fixture count, and whether wired or solar makes more sense for the site.", keywords: "lights lighting later solar wired power night fixture", href: "/products/dominator-basketball-court-light-full-assembly#product-decisions" },
    { question: "Which pickleball net is right?", answer: "Use portable nets for flexible home or shared spaces, Pro Portable for stronger repeated setup, and Pro Max when the court needs a more official club or event feel.", keywords: "pickleball net ppa portable pro max fixed club event", href: "/products/pro-max-rolling-portable-pickleball-net#product-decisions" },
    { question: "What does shipping look like?", answer: "Larger court products may need freight receiving details planned before checkout. Confirm address access, delivery timing, and who can receive oversized shipments.", keywords: "shipping freight delivery receiving ship cost", href: "/pages/resources" },
    { question: "I need parts, manuals, or warranty help.", answer: "Start with the product, order number if available, photos, and what changed. That gives support enough context to route parts, manuals, warranty, or troubleshooting.", keywords: "parts accessory manual warranty support replacement pad rim anchor", href: "/pages/resources" },
    { question: "Can I plan the whole court cost?", answer: "Use the planner to separate Dominator product cost from the broader court build. Surface, base prep, lines, lights, and install assumptions should stay visible before checkout.", keywords: "planner court cost estimate concrete surface lines budget", href: "/pages/court-planner" }
  ];

  const supportSuggestionScore = (query, item) => {
    const normalized = String(query || "").trim().toLowerCase();
    if (!normalized) return 1;
    return normalized.split(/\s+/).reduce((score, token) => {
      if (item.question.toLowerCase().includes(token)) return score + 4;
      if (item.keywords.toLowerCase().includes(token)) return score + 3;
      if (item.answer.toLowerCase().includes(token)) return score + 1;
      return score;
    }, 0);
  };

  const updateSupportSuggestions = (query = "") => {
    if (!supportDrawer) return;
    const shell = $("[data-support-suggestions]", supportDrawer);
    const list = $("[data-support-suggestion-list]", supportDrawer);
    const answer = $("[data-support-suggestion-answer]", supportDrawer);
    if (!shell || !list) return;
    const matches = supportSuggestionBank
      .map((item) => ({ ...item, score: supportSuggestionScore(query, item) }))
      .filter((item) => item.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 4);

    shell.hidden = matches.length === 0;
    list.innerHTML = matches.map((item, index) =>
      "<button type=\"button\" data-support-suggestion-option=\"" + index + "\">" +
      "<span>" + escapeHtml(item.question) + "</span>" +
      "<small>" + escapeHtml(item.answer.slice(0, 96)) + (item.answer.length > 96 ? "..." : "") + "</small>" +
      "</button>"
    ).join("");

    $$("[data-support-suggestion-option]", list).forEach((button) => {
      button.addEventListener("click", () => {
        const item = matches[Number(button.dataset.supportSuggestionOption) || 0];
        if (!item || !answer) return;
        const title = $("[data-support-suggestion-answer-title]", answer);
        const copy = $("[data-support-suggestion-answer-copy]", answer);
        const link = $("[data-support-suggestion-answer-link]", answer);
        if (title) title.textContent = item.question;
        if (copy) copy.textContent = item.answer;
        if (link) link.href = item.href;
        answer.hidden = false;
        $$("[data-support-suggestion-option]", list).forEach((candidate) => candidate.classList.toggle("selected", candidate === button));
        track("support_suggestion_select", { question: item.question, path: window.location.pathname });
      });
    });
  };

  const openSupport = (intent = "buying", query = "") => {
    if (!supportDrawer) return;
    supportDrawer.hidden = false;
    const mode = supportModes[intent] || supportModes.buying;
    const title = $("[data-support-title]", supportDrawer);
    const copy = $("[data-support-mode-copy]", supportDrawer);
    const intentField = $("[name='intent']", supportDrawer);
    const questionField = $("[name='question']", supportDrawer);
    const productField = $("[name='product']", supportDrawer);
    const sourceField = $("[name='source_url']", supportDrawer);
    const cartTokenField = $("[name='cart_token']", supportDrawer);
    const plannerField = $("[name='planner_context']", supportDrawer);
    if (title) title.textContent = mode[0];
    if (copy) copy.textContent = mode[1];
    if (intentField) intentField.value = intent;
    if (questionField && query) questionField.value = query;
    if (productField && productRoot) productField.value = productRoot.querySelector("h1")?.textContent?.trim() || productRoot.dataset.productHandle || "";
    if (sourceField) sourceField.value = window.location.href;
    if (cartTokenField) cartTokenField.value = window.DominatorTheme?.cartToken || "";
    if (plannerField) plannerField.value = window.DominatorPlanner?.currentPlan || "";
    updateSupportSuggestions(questionField?.value || query || intent);
    track("support_drawer_open", { intent, path: window.location.pathname });
  };

  const closeSupport = () => {
    if (supportDrawer) supportDrawer.hidden = true;
  };

  window.DominatorTheme = window.DominatorTheme || {};
  window.DominatorTheme.openSupport = openSupport;
  window.DominatorTheme.supportReady = true;


  const siteHeader = $(`[data-site-header]`);
  const headerInner = siteHeader ? $(".site-header__inner", siteHeader) : null;
  const syncHeaderOffset = () => {
    if (!siteHeader) return;
    const fullHeight = Math.ceil(siteHeader.getBoundingClientRect().height);
    const compactHeight = Math.ceil(headerInner?.getBoundingClientRect().height || fullHeight);
    document.documentElement.style.setProperty("--site-header-offset", `${fullHeight}px`);
    document.documentElement.style.setProperty("--sticky-header-offset", `${compactHeight}px`);
  };
  const updateHeaderState = () => {
    if (!siteHeader) return;
    siteHeader.classList.toggle("is-scrolled", window.scrollY > 6);
    window.requestAnimationFrame(syncHeaderOffset);
  };
  syncHeaderOffset();
  updateHeaderState();
  if (siteHeader && "ResizeObserver" in window) {
    new ResizeObserver(syncHeaderOffset).observe(siteHeader);
  }
  window.addEventListener("scroll", updateHeaderState, { passive: true });
  window.addEventListener("resize", syncHeaderOffset);

  const mobileMenu = $("[data-mobile-menu]");
  const mobileMenuToggle = $("[data-menu-toggle]");
  const openMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    mobileMenu.hidden = false;
    mobileMenuToggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("menu-open");
    track("mobile_menu_open", { path: window.location.pathname });
  };
  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    mobileMenu.hidden = true;
    mobileMenuToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("menu-open");
  };

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("click", () => {
      if (mobileMenu?.hidden === false) closeMobileMenu();
      else openMobileMenu();
    });
  }

  $$("[data-mobile-menu-close]").forEach((button) => {
    button.addEventListener("click", closeMobileMenu);
  });

  $$("[data-mobile-menu] a, [data-mobile-menu] [data-support-open]").forEach((item) => {
    item.addEventListener("click", closeMobileMenu);
  });

  $$("[data-support-open]").forEach((button) => {
    button.addEventListener("click", () => openSupport(button.dataset.supportIntent || "buying", button.dataset.supportQuery || ""));
  });

  $$("[data-support-close]").forEach((button) => {
    button.addEventListener("click", closeSupport);
  });

  const supportQuestion = $("[data-support-question]", supportDrawer || document);
  if (supportQuestion) {
    supportQuestion.addEventListener("input", () => updateSupportSuggestions(supportQuestion.value));
    supportQuestion.addEventListener("focus", () => updateSupportSuggestions(supportQuestion.value));
  }

  const supportForm = $("[data-support-form]");
  if (supportForm) {
    supportForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      const payload = Object.fromEntries(new FormData(supportForm).entries());
      const supportSubmit = $("[data-support-submit]", supportForm);
      const submitLabel = supportSubmit?.textContent || "Send question";
      if (supportSubmit) {
        supportSubmit.disabled = true;
        supportSubmit.textContent = "Sending";
      }
      if (supportStatus) supportStatus.textContent = "Sending your question...";
      payload.path = window.location.pathname;
      payload.href = window.location.href;
      payload.product_handle = $("[data-product-root]")?.dataset.productHandle || "";
      payload.cart_token = window.DominatorTheme?.cartToken || "";
      payload.planner_context = window.DominatorPlanner?.currentPlan || "";
      track("support_question_submit", { intent: payload.intent, path: payload.path });

      try {
        const response = await fetch("/apps/dominator/ask", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error("Support endpoint unavailable");
        if (supportStatus) supportStatus.textContent = "Thanks. Dominator received the question.";
      } catch (error) {
        if (supportStatus) supportStatus.textContent = "We could not confirm that your question was sent. Your message is still here. Please try again, or use the email or phone links below.";
      } finally {
        if (supportSubmit) {
          supportSubmit.disabled = false;
          supportSubmit.textContent = submitLabel;
        }
      }
    });
  }

  const homeHeroModes = {
    hoops: {
      title: "Build The Driveway They Remember",
      text: "The hoop is the product. The win is a driveway that becomes the place people keep coming back to.",
      primaryLabel: "Shop hoops",
      primaryHref: "/products/dominator-72-inch-basketball-hoop",
      buyHref: "/products/dominator-72-inch-basketball-hoop",
      heroImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/72PI1-scaled.jpg",
      productTitle: "72 Inch",
      productCopy: "From $2,899",
      productImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Untitled-Design-21.png"
    },
    pickleball: {
      title: "Make Every Rally Match Ready",
      text: "Real tension, fast setup, and a net system that makes the court feel ready before the first serve.",
      primaryLabel: "Shop nets",
      primaryHref: "/products/pro-max-rolling-portable-pickleball-net",
      buyHref: "/products/pro-max-rolling-portable-pickleball-net",
      heroImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/pb-pro-court-1.jpg",
      productTitle: "Pro Max Rolling Net",
      productCopy: "From $1,999",
      productImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/pb-max-primary.jpg"
    },
    lights: {
      title: "Own The Court After Sunset",
      text: "One more serve, one more rebound, and one more hour when the work becomes visible.",
      primaryLabel: "Shop lights",
      primaryHref: "/products/dominator-basketball-court-light-full-assembly",
      buyHref: "/products/dominator-basketball-court-light-full-assembly",
      heroImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/IMG_1698-scaled.jpg",
      productTitle: "Court Light System",
      productCopy: "Wired or solar systems",
      productImage: "https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Untitled-Design-16.png"
    }
  };

  const applyHomeHeroMode = (category) => {
    const data = homeHeroModes[category];
    const hero = $("[data-home-hero]");
    if (!hero || !data) return;

    hero.style.minHeight = Math.ceil(hero.getBoundingClientRect().height) + "px";

    ["hoops", "pickleball", "lights"].forEach((mode) => {
      hero.classList.toggle(`hero--${mode}`, mode === category);
    });

    const title = $("[data-home-hero-title]", hero);
    const copy = $("[data-home-hero-copy]", hero);
    const primary = $("[data-home-hero-primary]", hero);
    const buy = $("[data-home-hero-buy]", hero);
    const heroImage = $("[data-home-hero-image]", hero);
    const productImage = $("[data-hero-product-image]", hero);
    const productTitle = $("[data-hero-product-title]", hero);
    const productCopy = $("[data-hero-product-copy]", hero);

    if (title) title.textContent = data.title;
    if (copy) copy.textContent = data.text;
    if (primary) {
      primary.textContent = data.primaryLabel;
      primary.href = data.primaryHref;
    }
    if (buy) buy.href = data.buyHref;
    if (heroImage) {
      heroImage.src = data.heroImage;
      heroImage.alt = data.title;
    }
    if (productImage) {
      productImage.src = data.productImage;
      productImage.alt = data.productTitle;
    }
    if (productTitle) productTitle.textContent = data.productTitle;
    if (productCopy) productCopy.textContent = data.productCopy;
    window.requestAnimationFrame(() => {
      hero.style.minHeight = "";
    });
  };

  const reorderHomeProductRunway = (category) => {
    const runway = $("[data-home-system-showcases]");
    if (!runway) return;
    const groups = {
      hoops: ["hoops", "hoop-picker"],
      pickleball: ["pickleball", "net-picker"],
      lights: ["lights", "light-picker"]
    };
    const preferred = groups[category] || groups.hoops;
    const order = [preferred, ...Object.entries(groups).filter(([key]) => key !== category).map(([, ids]) => ids)];
    const heading = runway.querySelector(":scope > .section-heading");
    let anchor = heading ? heading.nextSibling : runway.firstChild;
    const beforeY = window.scrollY;
    order.flat().map((id) => document.getElementById(id)).filter(Boolean).forEach((section) => {
      runway.insertBefore(section, anchor);
      anchor = section.nextSibling;
    });
    if (Math.abs(window.scrollY - beforeY) > 1) window.scrollTo({ top: beforeY, left: window.scrollX });
  };

  $$("[data-category-tab]").forEach((tab) => {
    tab.addEventListener("click", () => {
      const category = tab.dataset.categoryTab;
      $$("[data-category-tab]").forEach((candidate) => {
        candidate.classList.toggle("is-active", candidate === tab);
        candidate.classList.toggle("selected", candidate === tab);
      });
      applyHomeHeroMode(category);
      reorderHomeProductRunway(category);
      track("homepage_category_switch", { category });
    });
  });

  window.DominatorTheme.homeTabsReady = true;

  $$('[data-decision-media-src]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-decision-media]');
      const main = $('[data-decision-media-main]', gallery || document);
      if (!main || !button.dataset.decisionMediaSrc) return;
      let image = $('img', main);
      const placeholder = $('.media-placeholder', main);
      if (!image) {
        image = document.createElement('img');
        image.loading = 'lazy';
        image.width = 760;
        image.height = 540;
        main.prepend(image);
      }
      if (placeholder) placeholder.remove();
      image.src = button.dataset.decisionMediaSrc;
      image.alt = button.dataset.decisionMediaTitle || '';
      const label = $('[data-decision-media-label]', main);
      const title = $('[data-decision-media-title]', main);
      if (label) label.textContent = button.dataset.decisionMediaLabel || '';
      if (title) title.textContent = button.dataset.decisionMediaTitle || '';
      $$('[data-decision-media-src]', gallery || document).forEach((candidate) => {
        candidate.classList.toggle('selected', candidate === button);
      });
      track('decision_media_select', { label: button.dataset.decisionMediaLabel || '', path: window.location.pathname });
    });
  });

  $$("[data-compare-expand]").forEach((button) => {
    button.addEventListener("click", () => {
      const card = button.closest('.comparison-card') || button.closest('[data-product-compare-card]') || button.parentElement;
      const details = card?.querySelector("[data-compare-details]");
      const extraRows = $$("[data-compare-extra]", card || button.parentElement || document);
      if (!details) return;
      details.hidden = !details.hidden;
      extraRows.forEach((row) => {
        row.hidden = details.hidden;
      });
      button.textContent = details.hidden ? "See all detailed specs" : "Hide all detailed specs";
      button.setAttribute("aria-expanded", String(!details.hidden));
      track("comparison_expand", { expanded: !details.hidden, path: window.location.pathname });
    });
  });

  window.DominatorTheme.compareBindingsReady = true;

  $$("[data-media-src]").forEach((button) => {
    button.addEventListener("click", () => {
      const gallery = button.closest("[data-product-media-gallery]");
      const main = $("[data-product-media-main]", gallery || document);
      if (!main || !button.dataset.mediaSrc) return;
      const src = button.dataset.mediaSrc;
      const kind = button.dataset.mediaKind || "image";
      const currentMedia = () => main.querySelector(':scope > img, :scope > video, :scope > model-viewer');
      const activateModelViewer = (model) => {
        if (!model) return;
        if (typeof model.dismissPoster === "function") {
          model.dismissPoster();
          return;
        }
        customElements.whenDefined("model-viewer").then(() => model.dismissPoster?.());
      };
      if (kind === "video") {
        currentMedia()?.remove();
        main.insertAdjacentHTML('afterbegin', `<video src="${src}" controls playsinline></video>`);
      } else if (kind === "model") {
        const modelId = button.dataset.mediaModelId;
        const template = gallery?.querySelector(`[data-media-model-template="${modelId}"]`);
        if (!template) return;
        currentMedia()?.remove();
        main.insertAdjacentHTML('afterbegin', template.innerHTML);
        activateModelViewer(main.querySelector(':scope > model-viewer'));
      } else {
        currentMedia()?.remove();
        const image = document.createElement('img');
        image.src = src;
        image.loading = 'eager';
        image.alt = button.dataset.mediaTitle || button.querySelector('img')?.alt || productRoot?.querySelector('h1')?.textContent.trim() || 'Product view';
        main.prepend(image);
      }
      $$('[data-media-src]', gallery || document).forEach((candidate) => {
        candidate.classList.toggle('is-active', candidate === button);
      });
      const caption = $('[data-media-caption]', gallery || document);
      if (caption) {
        const label = $('[data-media-caption-label]', caption);
        const title = $('[data-media-caption-title]', caption);
        if (label) label.textContent = button.dataset.mediaLabel || '';
        if (title) title.textContent = button.dataset.mediaTitle || '';
      }
    });
  });

  const productRoot = $("[data-product-root]");
  const variantData = (() => {
    try {
      return JSON.parse($("[data-product-variant-data]")?.textContent || "{}").variants || [];
    } catch {
      return [];
    }
  })();

  const selectedOptions = () => $$("[data-option-select]").map((select) => select.value);

  const selectedVariant = () => {
    const options = selectedOptions();
    if (!variantData.length) return null;
    return variantData.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variantData[0];
  };
  const isMeaningfulFinish = (value = '') => {
    const normalized = String(value || '').trim();
    return normalized && !/^default(?:\s+title)?$/i.test(normalized);
  };
  const selectedFinish = (variant) => {
    const raw = variant?.options?.[0] || variant?.title || '';
    return isMeaningfulFinish(raw) ? String(raw).trim() : '';
  };

  const syncVariantPills = () => {
    const options = selectedOptions();
    $$('[data-variant-pill]').forEach((button) => {
      const position = Number(button.dataset.optionPosition || 0);
      button.classList.toggle('is-active', options[position] === button.dataset.optionValue);
    });
  };

  const orderProperties = (id) => {
    const variant = variantData.find((entry) => String(entry.id) === String(id));
    return variant?.backorder ? { "Delivery": "Backorder — contact Dominator for delivery timing before ordering." } : {};
  };
  const syncStockStatus = () => {
    const variant = selectedVariant();
    if (!variant) return;
    $$('[data-product-add-submit], [data-sticky-add-button]').forEach((button) => {
      if (!button.dataset.inStockLabel) button.dataset.inStockLabel = button.textContent;
      button.disabled = !variant.available;
      button.textContent = !variant.available ? 'Sold out' : variant.backorder ? 'Backorder' : button.dataset.inStockLabel;
    });
    $$('[data-product-stock-status]').forEach((node) => {
      node.textContent = !variant.available ? 'This option is currently out of stock.' : variant.backorder ? 'Available on backorder. Contact us for delivery timing.' : '';
      node.hidden = variant.available && !variant.backorder;
    });
  };

  const syncVariant = () => {
    syncStockStatus();
    const variant = selectedVariant();
    if (!variant) return;
    const finish = selectedFinish(variant);
    const productTitle = $('h1')?.textContent?.trim() || 'Dominator product';
    const imageAlt = finish ? `${productTitle} ${finish} product image` : `${productTitle} product image`;
    $$('[data-variant-id-input]').forEach((input) => {
      input.value = variant.id;
    });
    $$('[data-sticky-variant-id]').forEach((input) => {
      input.value = variant.id;
    });
    $$('[data-product-price]').forEach((node) => {
      node.textContent = variant.formattedPrice;
    });
    $$('[data-sticky-price]').forEach((node) => {
      node.textContent = `${variant.formattedPrice} • ${node.dataset.shippingMessage || 'Free shipping in the contiguous U.S.'}`;
    });
    $$('[data-sticky-title]').forEach((node) => {
      const baseTitle = node.dataset.stickyBaseTitle || node.textContent.split('/')[0].trim();
      node.textContent = finish ? `${baseTitle} / ${finish}` : baseTitle;
    });
    $$('[data-product-finance]').forEach((node) => {
      node.textContent = variant.formattedFinance || '';
    });
    if (variant.featuredImage) {
      $$('[data-product-preview-image]').forEach((image) => {
        image.src = variant.featuredImage;
        image.alt = imageAlt;
      });
      const gallery = $('[data-product-media-gallery]');
      const main = $('[data-product-media-main]', gallery || document);
      if (main) {
        main.querySelector('video, model-viewer')?.remove();
        const existing = main.querySelector('img');
        if (existing) {
          existing.removeAttribute('srcset'); existing.src = variant.featuredImage;
          existing.alt = imageAlt;
        } else {
          main.insertAdjacentHTML('afterbegin', `<img src="${variant.featuredImage}" loading="eager" alt="${imageAlt}">`);
        }
      }
      const caption = $('[data-media-caption]', gallery || document);
      if (caption) {
        const label = $('[data-media-caption-label]', caption);
        const title = $('[data-media-caption-title]', caption);
        if (label) label.textContent = finish ? 'Selected finish' : 'Product shown';
        if (title) title.textContent = finish || productTitle;
      }
    }
    if (productRoot?.dataset.productHandle === 'portable-pickleball-net-replacement-parts') {
      const partFiles = {'Tube Section A':'2-poles-scaled_1.jpg','Tube Section B':'2-poles-2.jpg','Tube Section C':'6-poles-scaled.jpg','Tube Section D':'center-pole.jpg','Net Post':'2-round-poles-scaled.jpg','Center Dowel':'center-stick-scaled.jpg','Caster':'Wheel-scaled.jpg','Replacement Net':'net-2048x1202.png','Top Clip For Dowel':'Photoroom_20240216_140504.png'};
      const file = partFiles[variant.title];
      const thumb = file && $$('[data-product-media-gallery] [data-media-src]').find((button) => button.dataset.mediaSrc?.includes(file));
      if (thumb) { thumb.click(); const image = $('[data-product-media-main] img', productRoot); if (image) image.alt = variant.title + ' replacement part for the Dominator portable pickleball net'; }
    }
    syncVariantPills();
  };

  $$('[data-variant-pill]').forEach((button) => {
    button.addEventListener('click', () => {
      const selector = '[data-option-select][data-option-position="' + (button.dataset.optionPosition || '0') + '"]';
      const select = $(selector);
      if (!select) return;
      select.value = button.dataset.optionValue || select.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  $$('[data-quantity-row]').forEach((row) => {
    const input = $('[data-quantity-input]', row);
    const display = $('[data-quantity-display]', row);
    const setQuantity = (next) => {
      const value = Math.max(1, next);
      if (input) input.value = String(value);
      if (display) display.textContent = String(value);
    };
    $('[data-quantity-decrease]', row)?.addEventListener('click', () => setQuantity(Number(input?.value || 1) - 1));
    $('[data-quantity-increase]', row)?.addEventListener('click', () => setQuantity(Number(input?.value || 1) + 1));
  });

  $$('[data-product-form]').forEach((form) => {
    const button = $('[data-product-add-submit]', form);
    const status = $('[data-product-add-status]', form);
    const defaultLabel = button?.textContent || 'Add to cart';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = Number(formData.get('quantity') || 1);
      const safeQuantity = Number.isFinite(quantity) ? Math.max(1, quantity) : 1;
      if (!variantId) {
        form.submit();
        return;
      }
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding';
      }
      if (status) status.textContent = '';
      try {
        const response = await fetch(window.DominatorTheme.routes.cartAddJson || window.DominatorTheme.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: safeQuantity, properties: orderProperties(variantId) })
        });
        if (!response.ok) throw new Error('Cart add failed');
        if (button) button.textContent = 'Added';
        if (status) status.innerHTML = 'Added to cart. <a href="' + window.DominatorTheme.routes.cart + '">Review cart</a>';
        track('main_product_add_to_cart', { variant_id: String(variantId), quantity: safeQuantity });
      } catch {
        if (button) button.textContent = 'Retry add to cart';
        if (status) status.textContent = 'Cart add failed. Try again or text support.';
      } finally {
        setTimeout(() => {
          if (button) {
            button.disabled = false;
            if (button.textContent === 'Added') button.textContent = defaultLabel;
            syncStockStatus();
          }
        }, 1800);
      }
    });
  });

  $$('[data-product-question-bank]').forEach((bank) => {
    const input = $('[data-product-question-input]', bank);
    const submit = $('[data-product-question-submit]', bank);
    const items = $$('[data-product-question-item]', bank);
    const empty = $('[data-empty-question]', bank);
    const followup = $('[data-question-followup]', bank);
    const notify = $('[data-product-question-notify]', bank);
    const contact = $('[data-product-question-contact]', bank);

    const syncQuestions = () => {
      const query = (input?.value || '').trim().toLowerCase();
      let visibleCount = 0;
      items.forEach((item) => {
        const text = (item.dataset.questionText || item.textContent || '').toLowerCase();
        const visible = !query || text.includes(query);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      if (empty) empty.hidden = visibleCount > 0;
      if (submit) submit.textContent = visibleCount > 0 ? 'Submit new question' : 'Be the first to ask';
    };

    input?.addEventListener('input', syncQuestions);
    submit?.addEventListener('click', () => {
      if (followup) followup.hidden = false;
      track('product_question_start', { path: window.location.pathname, has_match: empty?.hidden !== false });
    });
    notify?.addEventListener('click', () => {
      const question = (input?.value || '').trim();
      const contactValue = (contact?.value || '').trim();
      const prompt = question ? 'Product question: ' + question : 'Please notify me when this product question is answered.';
      openSupport('contact', prompt);
      const contactField = $('[name="contact"]', supportDrawer || document);
      if (contactField && contactValue) contactField.value = contactValue;
      track('product_question_notify', { path: window.location.pathname, has_contact: Boolean(contactValue) });
    });
    syncQuestions();
  });

  const reviewFilters = $$('[data-review-filter]');
  const reviewItems = $$('[data-review-item]');
  reviewFilters.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.reviewFilter || 'All';
      reviewFilters.forEach((candidate) => {
        const selected = candidate === button;
        candidate.classList.toggle('selected', selected);
        candidate.setAttribute('aria-pressed', String(selected));
      });
      reviewItems.forEach((item) => {
        item.hidden = filter !== 'All' && item.dataset.reviewTag !== filter;
      });
      track('review_filter', { filter, path: window.location.pathname });
    });
  });

  $$('[data-final-help]').forEach((block) => {
    const input = $('[data-final-help-input]', block);
    const ask = $('[data-final-help-ask]', block);
    const contact = $('[data-final-help-contact]', block);
    const actions = $$('[data-final-help-action]', block);
    const openFinalHelp = (intent) => {
      const question = (input?.value || '').trim();
      const prompt = question ? 'Product help request: ' + question : 'I need help before buying this Dominator product.';
      openSupport(intent, prompt);
      track('final_help_submit', { intent, path: window.location.pathname, has_question: Boolean(question) });
    };
    if (actions.length) {
      actions.forEach((action) => {
        if (action.tagName === 'A') return;
        action.addEventListener('click', () => {
          const intent = action.dataset.supportIntent || (action.dataset.finalHelpAction === 'contact' ? 'contact' : 'buying');
          const query = action.dataset.supportQuery || '';
          const question = (input?.value || '').trim();
          const prompt = question || query ? ['Product help request:', question || query].filter(Boolean).join(' ') : 'I need help before buying this Dominator product.';
          openSupport(intent, prompt);
          track('final_help_submit', { intent, path: window.location.pathname, has_question: Boolean(question) });
        });
      });
    } else {
      ask?.addEventListener('click', () => openFinalHelp('buying'));
      contact?.addEventListener('click', () => openFinalHelp('contact'));
    }
  });

  if (productRoot && variantData.length) {
    $$('[data-option-select]').forEach((select) => {
      select.addEventListener('change', syncVariant);
    });
    syncVariant();
    window.DominatorTheme.variantBindingsReady = true;
  }

  const switchDrawer = $("[data-product-switch-drawer]");
  const openSwitchDrawer = () => {
    if (!switchDrawer) return;
    switchDrawer.hidden = false;
    document.body.style.overflow = "hidden";
    track("product_switch_drawer_open", { path: window.location.pathname });
  };

  const closeSwitchDrawer = () => {
    if (!switchDrawer) return;
    switchDrawer.hidden = true;
    document.body.style.overflow = "";
  };

  $$("[data-product-switch-open]").forEach((button) => {
    button.addEventListener("click", openSwitchDrawer);
  });

  $$("[data-product-switch-close]").forEach((button) => {
    button.addEventListener("click", closeSwitchDrawer);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeSwitchDrawer();
      closeMobileMenu();
    }
  });

  $$("[data-sticky-add-button]").forEach((button) => {
    button.addEventListener("click", async () => {
      const shell = button.closest("[data-sticky-add-to-cart]");
      const variantId = $("[data-sticky-variant-id]", shell)?.value;
      const quantity = Number($("[data-sticky-quantity]", shell)?.value || 1);
      if (!variantId) return;
      button.disabled = true;
      try {
        const response = await fetch(window.DominatorTheme.routes.cartAddJson || window.DominatorTheme.routes.cartAdd, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: Math.max(1, quantity), properties: orderProperties(variantId) })
        });
        if (!response.ok) throw new Error("Cart add failed");
        button.textContent = "Added";
        track("sticky_add_to_cart", { variant_id: variantId, quantity: Math.max(1, quantity) });
      } catch {
        button.textContent = "Retry";
      } finally {
        setTimeout(() => {
          button.disabled = false;
          if (button.textContent === "Added") button.textContent = "Add to cart";
          syncStockStatus();
        }, 1800);
      }
    });
  });

  $$("[data-quick-add]").forEach((button) => {
    button.addEventListener("click", async () => {
      const id = button.dataset.variantId;
      if (!id) return;
      button.disabled = true;
      try {
        await fetch(window.DominatorTheme.routes.cartAddJson || window.DominatorTheme.routes.cartAdd, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, quantity: 1 })
        });
        track("quick_add", { variant_id: id });
        button.textContent = "Added";
      } catch (error) {
        button.textContent = "Retry";
      } finally {
        setTimeout(() => {
          button.disabled = false;
          if (button.textContent === "Added") button.textContent = "Add";
        }, 1800);
      }
    });
  });

  const thumbNav = $("[data-thumb-nav]") || $(".thumb-nav");
  const thumbToggle = $("[data-thumb-toggle]", thumbNav || document);
  const thumbToggleLabel = $("[data-thumb-toggle-label]", thumbNav || document);
  const thumbGroups = ["products", "explore", "resources"];
  const setThumbGroup = (group = "") => {
    if (!thumbNav) return;
    thumbGroups.forEach((candidate) => thumbNav.classList.toggle(`thumb-nav--${candidate}-open`, candidate === group));
    $$('[data-thumb-group]', thumbNav).forEach((button) => button.classList.toggle('selected', button.dataset.thumbGroup === group));
    $$('[data-thumb-children]', thumbNav).forEach((candidate) => {
      candidate.hidden = candidate.dataset.thumbChildren !== group;
    });
  };
  const setThumbOpen = (open) => {
    if (!thumbNav || !thumbToggle) return;
    thumbNav.classList.toggle("is-open", open);
    thumbToggle.setAttribute("aria-expanded", String(open));
    if (thumbToggleLabel) thumbToggleLabel.textContent = open ? "Close" : "Nav";
    if (!open) setThumbGroup("");
  };
  if (thumbNav && thumbToggle) {
    setThumbGroup("");
    thumbToggle.addEventListener("click", () => setThumbOpen(!thumbNav.classList.contains("is-open")));
  }

  $$('[data-thumb-group]', thumbNav || document).forEach((button) => {
    button.addEventListener("click", () => {
      if (!thumbNav) return;
      const group = button.dataset.thumbGroup || "";
      const isSameOpenGroup = thumbNav.classList.contains(`thumb-nav--${group}-open`);
      setThumbOpen(true);
      setThumbGroup(isSameOpenGroup ? "" : group);
    });
  });

  $$(".thumb-nav a, .thumb-nav [data-support-open]").forEach((item) => {
    item.addEventListener("click", () => setThumbOpen(false));
  });
  if (thumbNav && thumbToggle) window.DominatorTheme.thumbNavReady = true;

  const setActiveProductSection = (sectionId = "") => {
    $$('[data-pdp-anchor-link]').forEach((link) => {
      const active = Boolean(sectionId) && link.dataset.pdpAnchorLink === sectionId;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    $$('[data-thumb-section-link]').forEach((link) => {
      link.classList.toggle('is-active', Boolean(sectionId) && link.dataset.thumbSectionLink === sectionId);
    });
  };

  const pdpAnchorNav = $('[data-pdp-anchor-nav]');
  if (pdpAnchorNav) {
    const links = $$('[data-pdp-anchor-link]', pdpAnchorNav);
    const sections = links
      .map((link) => document.getElementById(link.dataset.pdpAnchorLink))
      .filter(Boolean)
      .sort((a, b) => a.offsetTop - b.offsetTop);
    const productNavOffset = () => {
      const cssOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset'));
      const headerHeight = headerInner?.getBoundingClientRect().height || siteHeader?.getBoundingClientRect().height || 0;
      const anchorHeight = pdpAnchorNav.getBoundingClientRect().height || 0;
      return (Number.isFinite(cssOffset) ? cssOffset : headerHeight) + anchorHeight + 10;
    };
    const anchorIsSticky = () => {
      const cssTop = parseFloat(getComputedStyle(pdpAnchorNav).top);
      const stickyTop = Number.isFinite(cssTop) ? cssTop : (headerInner?.getBoundingClientRect().height || 0);
      return pdpAnchorNav.getBoundingClientRect().top <= stickyTop + 2;
    };
    const updateActiveFromScroll = () => {
      if (!sections.length) {
        setActiveProductSection('');
        return;
      }
      if (!anchorIsSticky()) {
        setActiveProductSection('');
        return;
      }
      const marker = productNavOffset();
      let current = '';
      for (const section of sections) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= marker && rect.bottom > marker) {
          current = section.id;
          break;
        }
      }
      if (!current) {
        sections.forEach((section) => {
          if (section.getBoundingClientRect().top <= marker) current = section.id;
        });
      }
      setActiveProductSection(current);
    };
    links.forEach((link) => {
      link.addEventListener('click', () => {
        setActiveProductSection(link.dataset.pdpAnchorLink || '');
        window.requestAnimationFrame(updateActiveFromScroll);
      });
    });
    updateActiveFromScroll();
    window.addEventListener('scroll', updateActiveFromScroll, { passive: true });
    window.addEventListener('resize', updateActiveFromScroll);
    window.addEventListener('hashchange', updateActiveFromScroll);
  }

  const planner = $("[data-planner-app]");
  if (planner) {
    const total = $("[data-planner-product-total]", planner);
    const items = $("[data-planner-items]", planner);
    const presets = {
      driveway: { total: "$2,499", items: ["72 inch hoop", "Anchor kit"] },
      "half-court": { total: "$3,435", items: ["72 inch hoop", "Wired court light"] },
      pickleball: { total: "$1,849", items: ["PRO MAX PORTABLE PICKLEBALL NET"] },
      "build-your-own": { total: "$0", items: ["Choose products from the planner controls."] }
    };
    $$("[data-planner-preset]", planner).forEach((button) => {
      button.addEventListener("click", () => {
        $$("[data-planner-preset]", planner).forEach((candidate) => candidate.classList.toggle("is-active", candidate === button));
        const preset = presets[button.dataset.plannerPreset] || presets["build-your-own"];
        if (total) total.textContent = preset.total;
        if (items) items.innerHTML = preset.items.map((item) => `<li>${item}</li>`).join("");
        track("planner_preset_select", { preset: button.dataset.plannerPreset });
      });
    });
    const addPlannerCart = $("[data-planner-add-cart]", planner);
    if (addPlannerCart) {
      addPlannerCart.addEventListener("click", () => {
        track("planner_add_to_cart", { mode: "planner_summary" });
        addPlannerCart.textContent = "Planner products ready for cart review";
      });
    }
  }

  let googleMapsPromise = null;
  const parseMapNumber = (value, fallback) => {
    const parsed = Number.parseFloat(String(value || ""));
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  const loadGoogleMaps = (apiKey) => {
    if (window.google?.maps?.importLibrary) return Promise.resolve(window.google.maps);
    if (googleMapsPromise) return googleMapsPromise;
    googleMapsPromise = new Promise((resolve, reject) => {
      const callbackName = "__dominatorInstallerMapReady";
      window[callbackName] = () => resolve(window.google.maps);
      const script = document.createElement("script");
      const params = new URLSearchParams({
        key: apiKey,
        loading: "async",
        callback: callbackName,
        v: "weekly"
      });
      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;
      script.onerror = () => reject(new Error("Google Maps failed to load"));
      document.head.appendChild(script);
    });
    return googleMapsPromise;
  };
  const addInstallerMapMarker = (map, position, label, title, infoWindow, markerNodes) => {
    const marker = document.createElement("span");
    marker.className = "dominator-map-marker";
    marker.textContent = label;
    marker.setAttribute("aria-label", title);
    marker.setAttribute("role", "button");
    marker.tabIndex = 0;
    marker.title = title;
    const openMarker = () => {
      markerNodes.forEach((node) => node.classList.remove("is-selected"));
      marker.classList.add("is-selected");
      map.panTo(position);
      if (map.getZoom() < 5) map.setZoom(5);
      if (infoWindow) {
        infoWindow.setContent(`<div class="dominator-map-info"><strong>${escapeHtml(title)}</strong><p>Use the filters and location field to request the right installer introduction.</p></div>`);
        infoWindow.setPosition(position);
        infoWindow.open({ map });
      }
      track("installer_map_marker", { title });
    };
    marker.addEventListener("click", openMarker);
    marker.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      openMarker();
    });
    markerNodes.push(marker);
    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function () {
      this.getPanes().overlayMouseTarget.appendChild(marker);
    };
    overlay.draw = function () {
      const point = this.getProjection().fromLatLngToDivPixel(new window.google.maps.LatLng(position));
      if (!point) return;
      marker.style.transform = `translate(${Math.round(point.x)}px, ${Math.round(point.y)}px) translate(-50%, -50%)`;
    };
    overlay.onRemove = function () {
      marker.remove();
    };
    overlay.setMap(map);
    return overlay;
  };
  const initInstallerMap = async (mapShell) => {
    const apiKey = mapShell.dataset.mapApiKey || "";
    const canvas = $("[data-installer-map-canvas]", mapShell);
    const status = $("[data-installer-map-status]", mapShell);
    if (!apiKey || !canvas) {
      mapShell.dataset.mapState = "fallback";
      return null;
    }
    try {
      await loadGoogleMaps(apiKey);
      const { Map, InfoWindow } = await window.google.maps.importLibrary("maps");
      const center = {
        lat: parseMapNumber(mapShell.dataset.mapCenterLat, 39.8283),
        lng: parseMapNumber(mapShell.dataset.mapCenterLng, -98.5795)
      };
      const map = new Map(canvas, {
        center,
        zoom: Number.parseInt(mapShell.dataset.mapZoom || "4", 10) || 4,
        clickableIcons: false,
        disableDefaultUI: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
        gestureHandling: "cooperative",
        keyboardShortcuts: true,
        zoomControl: true,
        backgroundColor: "#0b1020",
        styles: [
          { elementType: "geometry", stylers: [{ color: "#1f2937" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#d7deea" }] },
          { elementType: "labels.text.stroke", stylers: [{ color: "#0b1020" }] },
          { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#53657f" }] },
          { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#172033" }] },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          { featureType: "road", elementType: "geometry", stylers: [{ color: "#25344d" }] },
          { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
          { featureType: "transit", stylers: [{ visibility: "off" }] },
          { featureType: "water", elementType: "geometry", stylers: [{ color: "#0d2d52" }] }
        ]
      });
      const markerNodes = [];
      const infoWindow = new InfoWindow({
        pixelOffset: new window.google.maps.Size(0, -18)
      });
      $$("[data-map-pin]", mapShell).forEach((pin) => {
        const position = {
          lat: parseMapNumber(pin.dataset.mapPinLat, NaN),
          lng: parseMapNumber(pin.dataset.mapPinLng, NaN)
        };
        if (!Number.isFinite(position.lat) || !Number.isFinite(position.lng)) return;
        addInstallerMapMarker(
          map,
          position,
          pin.textContent.trim().slice(0, 3),
          pin.dataset.mapPinTitle || pin.textContent.trim() || "Installer coverage",
          infoWindow,
          markerNodes
        );
      });
      mapShell.classList.add("installer-map--google-ready");
      mapShell.dataset.mapState = "google";
      if (status) status.textContent = mapShell.dataset.mapReadyLabel || "Live service map";
      return map;
    } catch (error) {
      mapShell.dataset.mapState = "fallback";
      if (status) status.textContent = mapShell.dataset.mapFallbackLabel || "Installer coverage preview";
      console.info("Dominator installer map fallback", error);
      return null;
    }
  };
  $$("[data-installer-map]").forEach((mapShell) => {
    initInstallerMap(mapShell);
  });

  const installerForm = $("[data-installer-form]");
  if (installerForm) {
    const productSelect = $("[name='product']", installerForm);
    const serviceSelect = $("[name='service']", installerForm);
    $$("[data-product-filter]", installerForm).forEach((button) => {
      button.addEventListener('click', () => {
        if (productSelect) productSelect.value = button.dataset.productFilter || 'All';
        $$("[data-product-filter]", installerForm).forEach((candidate) => candidate.classList.toggle("selected", candidate === button));
        track('installer_product_filter', { product: button.dataset.productFilter || 'All' });
      });
    });
    $$("[data-service-filter]", installerForm).forEach((button) => {
      button.addEventListener('click', () => {
        if (serviceSelect) serviceSelect.value = button.dataset.serviceFilter || 'All';
        $$("[data-service-filter]", installerForm).forEach((candidate) => candidate.classList.toggle("selected", candidate === button));
        track('installer_service_filter', { service: button.dataset.serviceFilter || 'All' });
      });
    });
    installerForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      const payload = Object.fromEntries(new FormData(installerForm).entries());
      const results = $("[data-installer-results]");
      track("installer_search", payload);
      try {
        const params = new URLSearchParams();
        params.set("zip", payload.zip || "");
        params.set("product", payload.product || "All");
        params.set("service", payload.service || "All");
        params.set("limit", payload.limit || installerForm.closest("[data-installer-locator]")?.dataset.installerResultLimit || "3");
        const response = await fetch(`/apps/dominator/installer/search?${params.toString()}`);
        if (!response.ok) throw new Error("Installer endpoint unavailable");
        const data = await response.json();
        if (results) {
          const matches = Array.isArray(data.matches) ? data.matches : [];
          const cards = matches.map((match) => {
            const products = Array.isArray(match.products) ? match.products : [];
            const services = Array.isArray(match.services) ? match.services : [];
            const gallery = Array.isArray(match.gallery) ? match.gallery.filter(Boolean) : [];
            const location = [match.city, match.state].filter(Boolean).join(", ");
            const productTags = products.map((tag) => `<span class="installer-tag">${escapeHtml(tag)}</span>`).join("");
            const serviceTags = services.map((tag) => `<span class="installer-tag installer-tag--muted">${escapeHtml(tag)}</span>`).join("");
            const galleryLinks = gallery.slice(0, 6).map((url, index) => `<a href="${escapeHtml(url)}" target="_blank" rel="noopener">Image ${index + 1}</a>`).join("");
            return `
              <article class="installer-match-card">
                ${match.hero ? `<img class="installer-match-card__hero" src="${escapeHtml(match.hero)}" loading="lazy" width="420" height="260" alt="">` : ""}
                <div class="installer-match-card__body">
                  <div>
                    <span>${escapeHtml(match.tier || "Dominator reviewed")}</span>
                    <h3>${escapeHtml(match.name || "Installer help")}</h3>
                    <p>${escapeHtml(location || match.location || "Service area available by request")}</p>
                  </div>
                  <div class="installer-match-card__contact">
                    ${match.phone ? `<a href="tel:${escapeHtml(match.phone)}">${escapeHtml(match.phone)}</a>` : ""}
                    ${match.email ? `<a href="mailto:${escapeHtml(match.email)}">${escapeHtml(match.email)}</a>` : ""}
                  </div>
                  ${(productTags || serviceTags) ? `<div class="installer-tags">${productTags}${serviceTags}</div>` : ""}
                  <p>${escapeHtml(match.note || "Request an introduction so Dominator can route the next step.")}</p>
                  ${(match.description || galleryLinks) ? `<details class="installer-match-card__details"><summary>Profile details</summary>${match.description ? `<p>${escapeHtml(match.description)}</p>` : ""}${galleryLinks ? `<div class="installer-gallery-links">${galleryLinks}</div>` : ""}</details>` : ""}
                  <div class="installer-actions"><button class="button button--primary" type="button" data-support-open data-support-intent="installer">Request intro</button><button class="button button--secondary" type="button" data-support-open data-support-intent="installer" data-support-query="I have an installer question.">Ask install question</button></div>
                </div>
              </article>
            `;
          }).join("");
          results.classList.add("installer-list--has-results");
          results.innerHTML = `<div class="installer-results__intro"><span>Installer match</span><h2>${escapeHtml(data.heading)}</h2><p>${escapeHtml(data.message)}</p></div>${cards || '<article class="installer-match-card installer-match-card--empty"><div><span>Manual review</span><h3>Request an installer introduction.</h3><p>Send your zip and project type so Dominator can route the right next step.</p></div><button class="button button--primary" type="button" data-support-open data-support-intent="installer">Ask for installer help</button></article>'}`;
          $$("[data-support-open]", results).forEach((button) => button.addEventListener("click", () => openSupport(button.dataset.supportIntent || "installer")));
        }
      } catch (error) {
        if (results) {
          results.classList.add("installer-list--has-results");
          results.innerHTML = `<div class="installer-results__intro"><span>Manual review</span><h2>Request an installer introduction.</h2><p>Send your zip and project type so Dominator can route the right next step.</p></div><article class="installer-match-card installer-match-card--empty"><button class="button button--primary" type="button" data-support-open data-support-intent="installer">Ask for installer help</button></article>`;
          const button = $("[data-support-open]", results);
          if (button) button.addEventListener("click", () => openSupport("installer"));
        }
      }
    });
  }

  $$("[data-state-link-select]").forEach((select) => {
    select.addEventListener("change", () => {
      const url = select.value;
      if (url) window.location.href = url;
    });
  });
})();
